/* eslint-disable */
import * as React from "react";
import OrbitIcon from "../Icon";
export default function FlightDirect(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(OrbitIcon, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M17.043 8.683a.588.588 0 0 1 .852 0l2.922 2.921c.242.244.242.609 0 .792l-2.922 2.922a.554.554 0 0 1-.426.182c-.366 0-.609-.243-.609-.609V12.9L3.9 12.9a.9.9 0 0 1-.893-.787L3 12a.9.9 0 0 1 .9-.9l12.96-.001v-1.99c0-.146.039-.253.117-.353l.066-.073z"
  }));
}